export interface OpcionMaestro {
    id: number;
    nombre: string;
}


export interface FuncionEspecificaMaestro extends OpcionMaestro {
    subgrupoId: number;
}

export interface GrupoNutricionalMaestro extends OpcionMaestro {
    funcionEspecificaId: number;
}

export interface IngredienteActivoMaestro extends OpcionMaestro {
    grupoNutricionalId: number;
}

export type EspecieMaestro = OpcionMaestro;

export interface PresentacionProducto {
    empaque?: string;
    unidadMedida?: string;
    presentacion?: string;
    cantidad?: string | number;
    empaqueUnidadMedida?: {
        empaque?: { nombre?: string };
        unidadMedida?: { nombre?: string; abreviacion?: string };
    };
}

export interface ObservacionProducto {
    fecha: string;
    texto: string;
    usuario: string;
}

export type EstadoValidacionProducto =
    | 'Pendiente'
    | 'Aprobado'
    | 'En validación'
    | 'Ajustes denegados';

export const ESTADOS_VALIDACION: {
    label: string;
    value: EstadoValidacionProducto;
}[] = (
    [
        'Pendiente',
        'Aprobado',
        'En validación',
        'Ajustes denegados',
    ] as EstadoValidacionProducto[]
).map((value) => ({ label: value, value }));

export interface ProductoPlaguicidaEdicion {
    id: number;
    nombreComercial: string;
    numeroRegistroIca: string;
    casaProductora: string;
    origenDelProducto: string;
    empresa: string;
    presentaciones: PresentacionProducto[];
    subgrupoId: number | null;
    funcionEspecificaId: number | null;
    grupoNutricionalId?: number | null;
    funcionQuimicaId?: number | null;
    ingredienteActivoId?: number | null;
    composicionId?: number | null;
    nombreComunId: number | null;
    estadoValidacion: EstadoValidacionProducto;
    ultimaObservacion: string;
    historicoObservaciones: ObservacionProducto[];
}

export interface FiltrosEdicionMasiva {
    nombreComercial: string;
    numeroRegistroIca: string;
    especieId: number | '';
    etapaProductiva: string;
    subgrupoId: number | '';
    funcionEspecificaId: number | '';
    grupoNutricionalId: number | '';
    ingredienteActivoId: number | '';
    nombreComunId: number | '';
    estadoValidacion: EstadoValidacionProducto | '';
}

export const FILTROS_INICIALES: FiltrosEdicionMasiva = {
    nombreComercial: '',
    numeroRegistroIca: '',
    especieId: '',
    etapaProductiva: '',
    subgrupoId: '',
    funcionEspecificaId: '',
    grupoNutricionalId: '',
    ingredienteActivoId: '',
    nombreComunId: '',
    estadoValidacion: '',
};
